import { Card, Checkbox, FormControlLabel, Link, Paper, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Files from "utils/Files";
import Labels from "../../../../../lang/Labels_en";
import DialogAction from "../../../../system/dialog-action/DialogAction";
import OverviewService, { OverviewServiceType } from "./OverviewService";
import useStyles from "./OverviewStyle";

export default function Overview({ article, handleBack }: any) {
  const classes = useStyles();

  const {
    articleSave,
    submitDisabled,
    createOverallPdf,
    createOverall,
    checkbox,
    handleChange,
    confirmSubmission,
    confirmSubmissionAction,
  }: OverviewServiceType = OverviewService({
    article,
  });

  return (
    <div>
      <CssBaseline />
      <div className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography>
            Please read carefully submission guidelines and download the template. If the manuscript wasn’t submitted
            according to the guidelines, it will be returned for correction by the assistant editor.
          </Typography>
          <Link href={Files.TemplateDoc} variant="body2" target="_blank" style={{ color: "red" }}>
            Download the template
          </Link>
          <Grid container spacing={2}>
            <Grid item xs={6} spacing={2}>
              <Card className={classes.card}>
                <Typography variant="h6" id="tableTitle" component="div">
                  {Labels.GENERAL_INFORMATION}
                </Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>{Labels.TITLE}</TableCell>
                        <TableCell>{article.articleTitle}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>{Labels.MANUSCRIPT_CLASSIFICATION}</TableCell>
                        <TableCell>{article?.type?.name}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>{Labels.KEYWORDS}</TableCell>
                        <TableCell>
                          {article.keywords ? article.keywords.map((k: any) => k.keyword).join(", ") : ""}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid item xs={6} spacing={2}>
              <Card className={classes.card}>
                <Typography variant="h6" id="tableTitle" component="div">
                  {Labels.AUTHOR}
                </Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>{Labels.ORDER}</TableCell>
                        <TableCell>{Labels.NAME}</TableCell>
                        <TableCell>{Labels.EMAIL_ADDRESS}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {article.articleAuthors?.map((a: any, i: number) => (
                        <TableRow key={i + 1}>
                          <TableCell>{i + 1}</TableCell>
                          <TableCell>{`${a.firstName} ${a.lastName}`}</TableCell>
                          <TableCell>{a.email}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Card className={classes.card}>
                <Typography variant="h6" id="tableTitle" component="div">
                  {Labels.REVIEWERS}
                </Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>{Labels.REVIEWER_1}</TableCell>
                        <TableCell>{Labels.REVIEWER_2}</TableCell>
                        <TableCell>{Labels.EXCLUDED}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>{Labels.NAME}</TableCell>
                        <TableCell>{article?.reviewerOne?.name}</TableCell>
                        <TableCell>{article?.reviewerTwo?.name}</TableCell>
                        <TableCell>{article?.reviewerRemoved?.name}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>{Labels.RELATIONSHIP}</TableCell>
                        <TableCell>{article.relationshipOne}</TableCell>
                        <TableCell>{article.relationshipTwo}</TableCell>
                        <TableCell>{article.note}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Typography variant="h6" id="tableTitle" component="div" style={{ marginTop: 10 }}>
                  {Labels.SUGGEST_REVIEWER}
                </Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Full name</TableCell>
                        <TableCell>{Labels.EMAIL}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {article.suggestedReviewers?.map((suggestedReviewer: any) => (
                        <TableRow>
                          <TableCell>{suggestedReviewer.fullName}</TableCell>
                          <TableCell>{suggestedReviewer.email}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>

            <Grid item xs={6}>
              <Card className={classes.card}>
                <Typography variant="h6" id="tableTitle" component="div">
                  {Labels.PAPER_FILES}
                </Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>{Labels.FILE_NAME}</TableCell>
                        <TableCell>{Labels.FILE_DESIGNATION}</TableCell>
                        <TableCell>{Labels.FILE_TYPE}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {article.fileList?.map((file: any) => (
                        <TableRow>
                          <TableCell>
                            <Link href={file?.location} color="inherit" component="a" target="_blank">
                              {file.filename}
                            </Link>
                          </TableCell>
                          <TableCell>{file.type}</TableCell>
                          <TableCell>{file.fileType}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            </Grid>
            <Grid item xs={6}></Grid>
          </Grid>
          <Grid direction="row" justifyContent="flex-start" alignItems="center" style={{ display: "flex" }}>
            {createOverall ? (
              <FormControlLabel
                className={classes.checkboxOne}
                control={
                  <Checkbox
                    color="primary"
                    style={{ fontSize: 5 }}
                    checked={confirmSubmission}
                    onChange={confirmSubmissionAction}
                    name="one"
                  />
                }
                label={<Typography variant="body2">I confirm that I have reviewed the submission</Typography>}
              />
            ) : (
              <>
                <FormControlLabel
                  key="createOverall"
                  control={<Checkbox checked={createOverall} name={"createOverall"} readOnly={true} color="primary" />}
                  label={""}
                />
                <DialogAction
                  buttonName="click here to generate submission overview"
                  buttonVariant="text"
                  color={""}
                  buttonClass={classes.underlineText}
                  title={"Info"}
                  description={
                    "An overview is a provisional document that is visible only to you. Some figures or tables may be incorrectly formatted or may be missing. Despite the format shown in the overview, the original files will be uploaded and stored unchanged."
                  }
                  action={createOverallPdf}
                />
              </>
            )}
          </Grid>
          <Grid item spacing={2}>
            <FormControlLabel
              className={classes.checkboxOne}
              control={
                <Checkbox
                  color="primary"
                  style={{ fontSize: 5 }}
                  checked={checkbox.one}
                  onChange={handleChange}
                  name="one"
                />
              }
              label={
                <Typography variant="body2">
                  Submission of a manuscript for publication implies the transfer of the copyright from the author(s) to
                  the publisher and entails the author's irrevocable and exclusive authorization of the publisher to
                  collect any sums or considerations for copying or reproduction payable by third parties. By ticking
                  this box you agree to these terms.
                </Typography>
              }
            />
            <FormControlLabel
              control={<Checkbox color="primary" checked={checkbox.two} onChange={handleChange} name="two" />}
              label={
                <Typography variant="body2">
                  I would like to request English language correction at the price of 100 euro/1000 words. Rhinology
                  will proceed with this service after the Manuscript has been accepted and I agree to fully cover the
                  cost. * Disclaimer: In case auhor would like to request language correction sooner, he/she would need
                  to make a prepayment and acknowledge that it does not guarantee acceptance of the article . To request
                  such service please contact editing assistant assistant@rhinology.org
                </Typography>
              }
            />
          </Grid>
          <div className={classes.buttons}>
            <Button variant="outlined" color="primary" onClick={handleBack} className={classes.button}>
              {Labels.BACK}
            </Button>
            <Button
              disabled={!checkbox.one || submitDisabled || !confirmSubmission}
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={articleSave}
            >
              {Labels.FINISH}
            </Button>
          </div>
        </Paper>
      </div>
    </div>
  );
}
